import { Box, CardMedia, SxProps, Theme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import deepmerge from 'deepmerge';

interface YouTubeThumbnailProps {
    url: string;
    onError?: (hasError: boolean) => void;
    sx?: SxProps<Theme>;
}

export const extractVideoId = (url: string): string | null => {
    // Handle youtu.be short URLs
    const shortUrlPattern = /youtu\.be\/([a-zA-Z0-9_-]{11})/;
    const shortMatch = url.match(shortUrlPattern);
    if (shortMatch) {
        return shortMatch[1];
    }

    // Handle youtube.com URLs with v parameter
    const longUrlPattern = /[?&]v=([a-zA-Z0-9_-]{11})/;
    const longMatch = url.match(longUrlPattern);
    if (longMatch) {
        return longMatch[1];
    }

    // Handle embed URLs
    const embedPattern = /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/;
    const embedMatch = url.match(embedPattern);
    if (embedMatch) {
        return embedMatch[1];
    }

    return null;
};

export const getYouTubeThumbnail = (youtubeUrl: string): string | null => {
    const videoId = extractVideoId(youtubeUrl);
    if (videoId) {
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }
    return null;
};

export const cleanYouTubeUrl = (url: string): string => {
    const videoId = extractVideoId(url);
    if (videoId) {
        // Return clean YouTube watch URL with only video ID
        return `https://www.youtube.com/watch?v=${videoId}`;
    }
    // Return original URL if not a valid YouTube URL
    return url;
};

const YouTubeThumbnail: React.FC<YouTubeThumbnailProps> = ({ url, onError, sx = {} }) => {
    const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);


    useEffect(() => {
        if (!thumbnailUrl) onError?.(true);
        else onError?.(false);
    }, [thumbnailUrl]);

   

    React.useEffect(() => {
        const thumbnail = getYouTubeThumbnail(url);
        setThumbnailUrl(thumbnail);
    }, [url]);

    return (
        <Box
            id="thumbnail-ytb"
            sx={deepmerge<SxProps<Theme>>(
                {
                    borderRadius: 2.5,
                    mt: 10,
                    overflow: 'hidden',
                },
                sx
            )}
        >
            {thumbnailUrl && (
                <CardMedia
                    loading="lazy"
                    component={'img'}
                    src={thumbnailUrl}
                    alt=""
                    sx={{ borderRadius: 2.5, margin: '-10% 0', width: '100%' }}
                ></CardMedia>
            )}
        </Box>
    );
};

export default YouTubeThumbnail;
